import { render, staticRenderFns } from "./PriceDetail.vue?vue&type=template&id=6efdd27c&scoped=true"
import script from "./PriceDetail.vue?vue&type=script&lang=js"
export * from "./PriceDetail.vue?vue&type=script&lang=js"
import style0 from "./PriceDetail.vue?vue&type=style&index=0&id=6efdd27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efdd27c",
  null
  
)

export default component.exports